/* eslint-disable hubspot-dev/no-private-classes */

/**
 Internal QuantityNames BREEZE_INTELLIGENCE_CREDITS and UNIT not included
 */
export const QuantityNames = {
  CORE_SEAT: 'CORE_SEAT',
  SALES_SEAT: 'SALES_SEAT',
  SERVICE_SEAT: 'SERVICE_SEAT',
  COMMERCE_SEAT: 'COMMERCE_SEAT',
  FLEX_SEAT: 'FLEX_SEAT',
  FRONT_OFFICE_SEAT: 'FRONT_OFFICE_SEAT',
  CONTACTS: 'CONTACTS',
  EMAIL_SENDS: 'EMAIL_SENDS',
  TRANSCRIPT_HOURS: 'TRANSCRIPT_HOURS',
  SMS_INBOUND_OUTBOUND: 'SMS_INBOUND_OUTBOUND',
  CUSTOM_PROPERTIES: 'CUSTOM_PROPERTIES',
  WHATSAPP_CONVERSATIONS: 'WHATSAPP_CONVERSATIONS',
  EMBEDDABLE_VIDEOS: 'EMBEDDABLE_VIDEOS',
  CALCULATED_PROPERTIES: 'CALCULATED_PROPERTIES',
  CALLING_MINUTES_PER_PORTAL: 'CALLING_MINUTES_PER_PORTAL',
  CALLING_PURCHASED_PHONE_NUMBERS_PER_PORTAL: 'CALLING_PURCHASED_PHONE_NUMBERS_PER_PORTAL',
  USERS: 'USERS',
  BRAND_DOMAINS: 'BRAND_DOMAINS',
  WORKFLOWS: 'WORKFLOWS',
  TEAMS: 'TEAMS',
  OBJECT_LISTS_DYNAMIC: 'OBJECT_LISTS_DYNAMIC',
  CRM_CONTACTS: 'CRM_CONTACTS',
  CRM_OBJECTS: 'CRM_OBJECTS',
  API_CALLS_DAILY: 'API_CALLS_DAILY',
  HUBSPOT_CREDITS: 'HUBSPOT_CREDITS'
};
export default QuantityNames;